class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();
    this._qvEl = null;
    this._qvParent = null;

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      // Limpiar contenido
      const qv = this._qvEl || this.querySelector('quick-view');
      if (qv) {
        const content = qv.querySelector('.quick-view__content');
        if (content) {
          content.innerHTML = '';
          content.classList.remove('hide-cover');
        }
      }

      // Regresar quick-view a su lugar dentro de details
      if (this._qvEl && this._qvParent) {
        this._qvParent.appendChild(this._qvEl);
        this._qvEl = null;
        this._qvParent = null;
      }

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }

  openMenuDrawer(summaryElement = false) {
    setScrollbarWidth();
    setHeaderBottomPosition();

    if (summaryElement) {
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
    }

    // MOVER quick-view al body.
    // quick-view tiene position:fixed — visualmente igual.
    // Pero fuera del card-wrapper, el hover del panel ya NO
    // propaga :hover al card, eliminando el parpadeo.
    const qv = this.querySelector('quick-view');
    if (qv && qv.parentNode !== document.body) {
      this._qvParent = qv.parentNode;
      this._qvEl = qv;
      document.body.appendChild(qv);
    }

    document.body.classList.add(this.classes.opening);
    this.openAnimation();

    setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', '');
      setTimeout(() => this.mainDetailsToggle.classList.add('menu-opening'), 10);
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();
    this.addEventListener('click', (e) => {
      e.stopPropagation();
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper && wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();
        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: { productUrl: this.dataset.productUrl }
        }));
      } else if (this.dataset.productUrl) {
        window.location = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
    this._loaded = false;
    this._init = false;
    this._drawer = null;
    this._details = null;
  }

  connectedCallback() {
    // Guardar referencias en el primer connect (antes de cualquier move)
    if (this._init) return;
    this._init = true;

    this._details = this.closest('details');
    this._drawer = this.closest('quick-view-drawer');

    // Cargar contenido cuando details abre
    if (this._details) {
      this._details.addEventListener('toggle', () => {
        if (this._details.open) this.loadContent();
      });
    }

    // Resetear al cerrar
    if (this._drawer) {
      this._drawer.addEventListener('close', () => {
        this._loaded = false;
      });
    }

    // Cuando quick-view está en body, drawer:force-close no llega al drawer.
    // Lo interceptamos aquí y lo redirigimos al drawer original.
    this.addEventListener('drawer:force-close', (e) => {
      e.stopPropagation();
      if (this._drawer) this._drawer.closeMenuDrawer(e);
    });
  }

  loadContent() {
    if (this._loaded) return;
    this._loaded = true;

    const selector = '.quick-view__content';
    const content = this.querySelector(selector);
    if (!content) return;

    fetch(`${this.dataset.productUrl.split('?')[0]}?view=modal`)
      .then(r => r.text())
      .then(html => {
        setTimeout(() => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          this.setInnerHTML(content, doc.querySelector(selector).innerHTML);
          if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
        }, 200);

        setTimeout(() => {
          content.classList.add('hide-cover');
          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: { productUrl: this.dataset.productUrl }
          }));
        }, 500);
      })
      .catch(e => { this._loaded = false; console.error(e); });
  }

  setInnerHTML(el, html) {
    el.innerHTML = html;
    el.querySelectorAll('script').forEach(old => {
      const s = document.createElement('script');
      Array.from(old.attributes).forEach(a => s.setAttribute(a.name, a.value));
      s.appendChild(document.createTextNode(old.innerHTML));
      old.parentNode.replaceChild(s, old);
    });
  }
}
customElements.define('quick-view', QuickView);